<div class="w-full">
  <app-stepper (selectedIndexChange)="changeStep($event)" [(selectedIndex)]="selectedStep" [linear]="linear"
               [nextStepAllowed]="nextStepAllowed" [previousStepAllowed]="previousStepAllowed"
               class="flex flex-row h-full w-full">
    @if (isCheckView) {
    <cdk-step [label]="'Prüfregelauswahl'">
    </cdk-step>
    <cdk-step [label]="'Dateiauswahl'">
    </cdk-step>
      <cdk-step [label]="'Prüfergebnisse'">
    </cdk-step>
    } @else {
    <cdk-step [label]="'BIM-Basis-Check'" [completed]="true">
    </cdk-step>
      <cdk-step [label]="detailCheckLabel" [completed]="true">
      </cdk-step>
    }
  </app-stepper>
</div>
